import React, { PropTypes, Component } from 'react';
import { Styles, Paper, IconButton } from 'material-ui';
import SearchBar from 'components/SearchBar';

const { Spacing } = Styles;

const styles = {
  root: {
    height: Spacing.desktopToolbarHeight,
    padding: (Spacing.desktopToolbarHeight - 36) / 2,
    textAlign: 'center',
    boxSizing: 'border-box'
  }
};

export default class SearchBarToolbar extends Component {
  static displayName = 'SearchBarToolbar';

  static defaultProps = {
    backgroundColor: 'transparent'
  };

  getStyle() {
    let style = Object.assign({}, styles.root);
    style.backgroundColor = this.props.backgroundColor;
    if (this.props.fullWidth) {
      style.padding = `${(Spacing.desktopToolbarHeight - 36) / 2}px ${
        Spacing.desktopGutter
      }px`;
    }
    return style;
  }

  render() {
    return (
      <div style={this.getStyle()}>
        <SearchBar {...this.props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/SearchBarToolbar.js